<template>
  <v-radio-group
    v-model="model"
    :row="inline"
    @change="onChange"
    @blur="onBlur"
    :dark="darkEnabled"
  >
    <template v-for="(radio, index) in vradios">
      <v-tooltip
        v-if="radio.help"
        :key="'tooltip-' + randomId + '-' + index"
        bottom
      >
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-radio
              :disabled="radio.disabled || disabled"
              :readonly="radio.readonly || readonly"
              :label="radio.label"
              color="primario"
              :value="radio.value"
              :dark="darkEnabled"
            />
          </div>
        </template>
        {{ radio.help }}
      </v-tooltip>

      <v-radio
        v-else
        :key="'radio-' + randomId + '-' + index"
        :disabled="radio.disabled || disabled"
        :readonly="radio.readonly || readonly"
        :label="radio.label"
        color="primario"
        :value="radio.value"
        :dark="darkEnabled"
      />
    </template>
  </v-radio-group>
</template>

<script>
import * as _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "FormRadioGroup",
  props: {
    value: [String, Boolean, Number],
    radios: {
      type: Array,
      default: () => [],
      required: true
    },
    inline: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    model: "",
    randomId: Math.random() * 1000
  }),
  watch: {
    value: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal && newVal != this.model) {
          this.model = newVal;
        }
      }
    }
  },
  computed: {
    ...mapGetters(["darkEnabled"]),
    vradios() {
      return (this.radios || []).map(radio => {
        return {
          label: _.get(radio, "label", ""),
          value: _.get(radio, "value", ""),
          help: _.get(radio, "help", ""),
          disabled: _.get(radio, "disabled", false),
          readonly: _.get(radio, "readonly", false)
        };
      });
    }
  },
  methods: {
    onChange() {
      this.$emit("change", this.model);
      this.$emit("input", this.model);
    },
    onBlur() {
      this.$emit("blur");
    }
  },
  created() {
    this.model = this.value;
  }
};
</script>
